import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";

export class DailyBonusConfig extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!this.reward || !this.reward.valid() || this.reward.count != 7) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DailyBonusConfig());
        } else if (target instanceof DailyBonusConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DailyBonusConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _reward: alias("reward", RewardBunch.schema())
});